import React, { FC } from 'react';
import { EnvironmentFilled } from '@ant-design/icons';

import { PresenceStatus } from '../../../../models/types';
import { mapColor } from '../../../../theme';

import { PRESENCE_STATUS_LABEL } from '../../../../utils/employeePresence';

interface IProps {
  status?: PresenceStatus;
  unknown?: boolean;
}

const circleStyle = (color: string): React.CSSProperties => ({
  display: 'inline-block',
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: color,
  flexShrink: 0
});

const PresenceStatusCell: FC<IProps> = ({ status, unknown = false }) => {
  if (unknown || status == null) {
    return (
      <span style={{ color: mapColor.greyChateau, whiteSpace: 'nowrap' }}>—</span>
    );
  }

  const label = PRESENCE_STATUS_LABEL[status];

  let icon: React.ReactNode;
  if (status === 'on_plan') {
    icon = <EnvironmentFilled style={{ color: mapColor.mtsRed, fontSize: 14 }} />;
  } else if (status === 'online') {
    icon = <span style={circleStyle(mapColor.sinApple)} />;
  } else {
    icon = <span style={circleStyle(mapColor.greyChateau)} />;
  }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        whiteSpace: 'nowrap',
        color: mapColor.blackSmoke
      }}
    >
      {icon}
      {label}
    </span>
  );
};

export default PresenceStatusCell;
